(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amouri-image-collage"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlider(slider) {
    if (slider.dataset.aicReady === '1') return;
    var vp = slider.querySelector('.aic-viewport');
    if (!vp) return;
    var track = vp.querySelector('.aic-track');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var dotsWrap = slider.querySelector('.aic-dots');
    var prev = slider.querySelector('.aic-nav--prev');
    var next = slider.querySelector('.aic-nav--next');
    if (slides.length <= 1) {
      if (dotsWrap) dotsWrap.style.display = 'none';
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
      slider.dataset.aicReady = '1';
      return;
    }
    slider.dataset.aicReady = '1';

    var dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      slides.forEach(function (s, idx) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'aic-dot';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
        b.addEventListener('click', function () { scrollToIndex(idx); });
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }

    function scrollToIndex(idx) {
      var s = slides[idx];
      if (!s) return;
      var left = s.offsetLeft - (vp.clientWidth - s.offsetWidth) / 2;
      vp.scrollTo({ left: left, behavior: 'smooth' });
    }

    function current() {
      var center = vp.scrollLeft + vp.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      slides.forEach(function (s, idx) {
        var sc = s.offsetLeft + s.offsetWidth / 2;
        var d = Math.abs(sc - center);
        if (d < bestDist) { bestDist = d; best = idx; }
      });
      return best;
    }

    function update() {
      var idx = current();
      dots.forEach(function (d, i) {
        d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
      if (prev) prev.disabled = idx <= 0;
      if (next) next.disabled = idx >= slides.length - 1;
    }

    if (prev) prev.addEventListener('click', function () { scrollToIndex(Math.max(0, current() - 1)); });
    if (next) next.addEventListener('click', function () { scrollToIndex(Math.min(slides.length - 1, current() + 1)); });

    var ticking = false;
    vp.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { update(); ticking = false; });
    });
    window.addEventListener('resize', update);
    update();
  }

  function initSection(root) {
    if (!root) return;
    root.querySelectorAll('.aic-slider').forEach(initSlider);
  }

  function initAll() {
    document.querySelectorAll('.amouri-image-collage').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.amouri-image-collage');
    if (root) { root.querySelectorAll('.aic-slider').forEach(function (s) { s.dataset.aicReady = ''; }); initSection(root); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  const section = document.getElementById('carousel-{{ section_id }}');
  if (!section) return;

  const wrapper = section.querySelector('.itc-track-wrapper');
  const track   = section.querySelector('.itc-track');
  const prevBtn = section.querySelector('.itc-arrow--prev');
  const nextBtn = section.querySelector('.itc-arrow--next');

  if (!wrapper || !track) return;

  function getScrollAmount() {
    const slide = track.querySelector('.itc-slide');
    if (!slide) return wrapper.offsetWidth * 0.8;
    const gap = parseFloat(getComputedStyle(track).gap) || 0;
    return slide.offsetWidth + gap;
  }

  function update() {
    const atStart = wrapper.scrollLeft <= 2;
    const atEnd   = wrapper.scrollLeft + wrapper.offsetWidth >= wrapper.scrollWidth - 2;
    if (prevBtn) prevBtn.disabled = atStart;
    if (nextBtn) nextBtn.disabled = atEnd;
    wrapper.classList.toggle('is-scrolled-start', !atStart);
    wrapper.classList.toggle('is-scrolled-end',   atEnd);
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      wrapper.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      wrapper.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });
  }

  wrapper.addEventListener('scroll', update, { passive: true });
  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
